module.exports = __webpack_public_path__ + "static/media/arrow_left.61d4fec3.svg";